import { Modal } from "staysure-component-library";

import { TextButton } from "@/app/shared-components/cta-button/cta-buttons";
import RichText from "@/components/atoms/rich-text/rich-text";
import { findCustomFcdoMessage } from "@/utils/question-location-to.utils";
import { CustomFcdoMessage } from "@/utils/schema/location-to-page-schema.utils";

import styleComponent from "./location-to-container.module.css";

type FCDOCountryAndDuplicateCountryModalProps = {
  fcdoCountry: boolean;
  setFcdoCountry: React.Dispatch<React.SetStateAction<boolean>>;
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  fcdoCountrySubTextText: string | undefined;
  sameCountrySubTextText: string | undefined;
  fcdoCountryBtnText: string | undefined;
  sameCountryBtnText: string | undefined;
  fcdoCountryHeaderText: string | undefined;
  sameCountryHeaderText: string | undefined;
  customFcdoMessages: CustomFcdoMessage;
  selectedCountryCode: string | undefined;
};

function FCDOCountryAndDuplicateCountryModal(
  props: Readonly<FCDOCountryAndDuplicateCountryModalProps>
) {
  const {
    fcdoCountry,
    setFcdoCountry,
    isModalOpen,
    setIsModalOpen,
    fcdoCountrySubTextText,
    sameCountrySubTextText,
    fcdoCountryBtnText,
    sameCountryBtnText,
    fcdoCountryHeaderText,
    sameCountryHeaderText,
    customFcdoMessages,
    selectedCountryCode,
  } = props;

  // Find custom FCDO message for the selected country
  const customMessage = findCustomFcdoMessage(
    selectedCountryCode,
    customFcdoMessages
  );

  // Use custom message if available, otherwise fall back to default CMS content
  // If customMessage exists, use ONLY its fields (no fallback to default FCDO text)
  const headerText = fcdoCountry
    ? customMessage
      ? customMessage.header
      : fcdoCountryHeaderText
    : sameCountryHeaderText ?? "Information";

  const subText = fcdoCountry
    ? customMessage
      ? customMessage.description
      : fcdoCountrySubTextText
    : sameCountrySubTextText;

  const buttonText = fcdoCountry
    ? customMessage
      ? customMessage.ctaLabel
      : fcdoCountryBtnText || "Cancel"
    : sameCountryBtnText ?? "Cancel";

  return (
    <Modal
      className={`date-picker-modal md:p-spacing-xxxl justify-center p-spacing-l ${
        fcdoCountry ? "md:max-w-[416px]" : "md:max-w-[327px]"
      }
  ${fcdoCountry ? "max-w-[327px]" : "max-w-[267px]"}   w-full`}
      isOpen={isModalOpen}
      onOpenChange={(e: boolean) => setIsModalOpen(e)}
      underlayStyles={{
        zIndex: 9999,
        background: "rgba(26, 26, 26, 0.6)",
      }}
      modalStyles={{
        display: "flex",
        background: "white",
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        borderRadius: 8,
      }}
    >
      <div>
        <h1 className="text-text-title font-header-font md:text-3xl text-[23px] text-center md:leading-[34.1px] leading-[27.6px] md:mb-spacing-s mb-spacing-xs">
          {headerText}
        </h1>

        <div className={` ${styleComponent.text_content}`}>
          {fcdoCountry ? <RichText richText={subText ?? ""} /> : subText}
        </div>
        <div className="flex flex-row">
          <TextButton
            id="location-to-fcdo-country-button"
            hierarchy="primary"
            label={buttonText}
            onClick={() => {
              setFcdoCountry(false);
              setIsModalOpen(false);
            }}
            className="m-0 h-[48px] text-text-on-primary font-lg leading-[18px] font-semibold "
          />
        </div>
      </div>
    </Modal>
  );
}

export default FCDOCountryAndDuplicateCountryModal;
